import { FontAwesome5 } from '@expo/vector-icons';
import { styled, ThemeType } from '@openeducation/oe-rn-themes';
import React, { useEffect, useState } from 'react';
import {
  ImageSourcePropType,
  StyleProp,
  View,
  ViewProps,
  ViewStyle,
} from 'react-native';

import { borderRadius, width } from '../../style-utils';
import { Loading } from '../loading/loading';
import { OEText } from '../oe-text/oe-text';

export interface AvatarProps extends ViewProps {
  name?: string;
  image?: ImageSourcePropType;
  loading?: boolean;
  isLoadingEnabled?: boolean;
  size?: number;
  style?: StyleProp<ViewStyle>;
}

export const Avatar = ({
  name,
  image,
  loading = true,
  isLoadingEnabled = true,
  size = 80,
  style,
  ...rest
}: AvatarProps) => {
  const [imageIsLoading, setImageIsLoading] = useState(loading);

  useEffect(() => setImageIsLoading(loading), [loading]);

  useEffect(() => {
    if (!isLoadingEnabled) {
      setImageIsLoading(false);
      return;
    }

    if (image) {
      setImageIsLoading(true);
    } else {
      setImageIsLoading(false);
    }
  }, [image, isLoadingEnabled]);

  return (
    <View style={[width(size), style]} {...rest}>
      <ImageContainer size={size}>
        {imageIsLoading && (
          <LoadingBox style={[borderRadius(size)]}>
            <Loading />
          </LoadingBox>
        )}
        {image ? (
          <Image
            onLoad={() => setImageIsLoading(false)}
            source={image}
            size={size}
          />
        ) : (
          <UserIcon size={size} />
        )}
      </ImageContainer>
      {!!name && <Name>{name}</Name>}
    </View>
  );
};
interface ImageProps {
  size: number;
  theme: ThemeType;
}
const Image = styled.Image<ImageProps>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 2}px;
`;
const ImageContainer = styled.View<ImageProps>`
  background: ${({ theme }) => theme.color.border};
  border-radius: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  justify-content: center;
  align-items: center;
`;
const Name = styled(OEText).attrs({ fontType: 'bold' })`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  margin-top: 8px;
`;
const LoadingBox = styled.View`
  background-color: white;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
const UserIcon = styled(FontAwesome5).attrs(({ theme, size }: ImageProps) => ({
  color: theme.color.white,
  size: size * 0.35,
  name: 'user',
  solid: true,
}))``;
